import { createRoute } from "../../../utils";

import { conferencePapersRoutesObj, conferencePaperBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const conferencePapersRouteMetadata: IRouteMetadataObj<
  typeof conferencePapersRoutesObj
> = {
  list: {
    title: "conferencePapersList",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/conferencePaper/table/page"
      ),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewPaper",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/conferencePaper/form/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editPaperOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/conferencePaper/form/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewPaperOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/conferencePaper/form/page"
      ),
    mode: "view",
    permission,
  },
};

export const conferencePapersRoutes = createRoute<
  typeof conferencePapersRoutesObj
>(
  conferencePapersRoutesObj,
  conferencePapersRouteMetadata,
  conferencePaperBreadcrumbs,
);
